<template>
  <img
    class="active-img"
    :src="src"
    :class="className"
    :style="{ 'min-height': minHeight, 'max-height': maxHeight }"
    @error="checkError"
    @load="checkSucc"
  />
</template>
<script>
export default {
  props: ["src", "minHeight", "maxHeight", "className", "errorImg"],
  methods: {
    checkError(e) {
      if (this.errorImg) {
        e.target.src = this.errorImg
      } else {
        e.target.style.visibility = "hidden"
      }
    },
    checkSucc(e) {
      e.target.style.visibility = "visible"
    }
  }
}
</script>
